<template>
  <span
    class="buy-product__current-price"
    v-html="currentPrice" />
  <s
    v-if="hasOldPrice"
    class="buy-product__old-price"
    v-html="oldPrice" />
</template>

<script>
import { useUserStore } from "~/stores/user";

export default {
  props: {
    currentPrice: String,
    oldPrice: String,
  },
  setup() {
    const userStore = useUserStore();

    return { userStore }
  },
  computed: {
    userCurrency () {
      return this.userStore.getSelectedCurrency
    },
    hasOldPrice () {
      return this.oldPrice && this.oldPrice !== this.currentPrice
    },
  },
}
</script>